import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");

  return (
    <section className="relative min-h-[520px] md:min-h-[640px] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20flatlay%20with%20sneakers%20hoodies%20tshirts%20accessories%20on%20warm%20beige%20background%20soft%20natural%20light%20editorial%20product%20photography%20clean%20aesthetic%20high%20detail&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="Fashion products background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
        <span className="inline-block px-3 py-1.5 rounded-full bg-accent-500/20 text-accent-100 text-xs font-medium tracking-wider uppercase mb-6 backdrop-blur-sm border border-accent-500/20">
          {t("hero.eyebrow")}
        </span>

        <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6 max-w-4xl mx-auto">
          {t("hero.h1")}
        </h1>

        <p className="text-base md:text-lg text-background-100/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t("hero.subheadline")}
        </p>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-8">
          <div className="flex items-center bg-background-50/95 backdrop-blur-sm rounded-xl border border-background-200/50 overflow-hidden shadow-lg">
            <i className="ri-search-line text-foreground-400 ml-4 text-lg" />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={t("hero.searchPlaceholder")}
              className="flex-1 px-3 py-3.5 text-sm text-foreground-950 bg-transparent outline-none placeholder:text-foreground-400"
            />
            <button className="px-5 py-3 bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">
              {t("nav.search")}
            </button>
          </div>
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors shadow-lg shadow-primary-500/20 whitespace-nowrap"
          >
            {t("hero.ctaPrimary")}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-6 py-3 rounded-lg bg-background-50/10 backdrop-blur-sm text-background-50 font-medium text-sm border border-background-50/20 hover:bg-background-50/20 transition-colors whitespace-nowrap"
          >
            {t("hero.ctaSecondary")}
          </a>
        </div>

        <p className="text-xs text-background-100/70 tracking-wide">
          {t("hero.trust")}
        </p>
      </div>
    </section>
  );
}